<template>
  <boxwrap class="whitelist--inner">
     <toolbar>
      <toolbar-items>
        <!-- select-list
          class="toolbar-nav"
          :title="$route.params.subtype"
          v-model="selectedList"
        >
          <select-option
            value="all"
            name="all"
          >
            <span>all</span>
          </select-option>

          <select-option
            value="active"
            name="active"
          >
            <span>active</span>
          </select-option>

          <select-option
            value="inactive"
            name="inactive"
          >
            <span>inactive</span>
          </select-option>

          <select-option
            value="deleted"
            name="deleted"
          >
            <span>deleted</span>
          </select-option>
        </select-list -->

        <search
          class="search-bar-wrap"
          :dateBy="dateBy"
          :filterBy="filterBy"
          @refresh="search"
          @trigger="trigger"
          @clear="search"
        >
        </search>

        <button
          class="btn--create"
          title="create"
          @click="createViewer()"
        >
          <i class="ico--create"></i>
        </button>

        <div class="toolbar-rightbtns">
          <!-- button
            class="btn--tbl-settings"
            @click="showTblSettings = true"
          >
            <i class="ico--settings"></i>
          </button -->
        </div>
      </toolbar-items>
    </toolbar>

    <boxwrap-contents :class="{'data-loading': showDataLoading}">
      <check-data-list
        label="loading"
        v-if="isDataLoading || isEmpty"
        :isLoading="!isDataLoading"
        :isEmpty="isEmpty"
      >
      </check-data-list>

      <tbl
        :scrollable="true"
      >
        <tbl-inner>
          <tbl-head>
            <tbl-row>
              <tbl-td
                :sort="true"
                v-if="checkCol('id', tblSetting)"
                @click.native="sort('id')"
                name="no"
              >
                번호
              </tbl-td>

              <tbl-td
                :sort="true"
                v-if="checkCol('ip', tblSetting)"
                @click.native="sort('ip')"
                name="ip"
              >
                IP
              </tbl-td>

              <tbl-td
                :sort="true"
                v-if="checkCol('description', tblSetting)"
                @click.native="sort('description')"
                name="description"
              >
                설명
              </tbl-td>

              <!-- tbl-td
                :sort="true"
                v-if="checkCol('status', tblSetting)"
                @click.native="sort('status')"
                name="status"
              >
                status
              </tbl-td -->

              <tbl-td
                :sort="true"
                v-if="checkCol('created_at', tblSetting)"
                @click.native="sort('created_at')"
                name="created_at"
              >
                등록일자
              </tbl-td>

              <!-- tbl-td
                :sort="true"
                v-if="checkCol('updated_at', tblSetting)"
                @click.native="sort('updated_at')"
                name="updated_at"
              >
                updated at
              </tbl-td -->

              <!-- tbl-td
                :sort="true"
                v-if="checkCol('deleted_at', tblSetting)"
                @click.native="sort('deleted_at')"
                name="deleted_at"
              >
                deleted at
              </tbl-td -->

              <tbl-td
                name="td-delete"
              >
              </tbl-td>
            </tbl-row>
          </tbl-head>

          <tbl-body>
            <tbl-row
              v-for="w in whitelists"
              :key="w.id"
            >
              <tbl-td name="no">
                {{ w.id }}
              </tbl-td>

              <tbl-td name="ip">
                {{ w.ip }}
              </tbl-td>

              <tbl-td name="description">
                {{ w.description }}
              </tbl-td>

              <!-- tbl-td name="status">
                {{ w.status }}
              </tbl-td -->

              <tbl-td name="created_at">
                {{ dateFormatter(w.created_at) }}
              </tbl-td>

              <!-- tbl-td name="updated_at">
                {{ w.updated_at }}
              </tbl-td> -->

              <!-- <tbl-td name="deleted_at">
                {{ w.deleted_at }}
              </tbl-td -->

              <tbl-td name="td-delete">
                <button
                  @click="remove(w)"
                  class="btn--delete"
                  title="remove"
                >
                  <i class="ico--delete"></i>
                </button>
              </tbl-td>
            </tbl-row>
          </tbl-body>
        </tbl-inner>

        <tbl-footer>
          <pagination
            :total="parseInt(whitelistsCount)"
            v-model="params.page"
            :rows="params.rows"
            @page="trigger"
          >
          </pagination>
        </tbl-footer>
      </tbl>
    </boxwrap-contents>

      <modal
        class="modal--add-ip"
        title="아이피 추가"
        v-if="showCreate"
        :activate="showCreate"
        @activate="showCreate = false"
      >
        <template slot="body">
          <div class="form-con">
            <div class="form-items">
              <div class="form-lbl">
                IP
              </div>

              <div class="input-wrap">
                <input
                  type="text"
                  placeholder="IP"
                  v-model="tempWhitelist.ip"
                />
              </div>
            </div>
            <div class="form-items">
              <div class="form-lbl">
                메모
              </div>

              <div class="input-wrap">
                <input
                  type="text"
                  placeholder="메모"
                  v-model="tempWhitelist.description"
                />
              </div>
            </div>
          </div>
        </template>

        <template slot="footer">
          <button
            class="btn--create -withlabel -right"
            @click="saveWhiteList()"
          >
            <i class="ico--create"></i>
            <span>
              추가
            </span>
          </button>
        </template>
      </modal>
  </boxwrap>
</template>

<script type="text/javascript">

// components
import Checkbox from '@/components/base/Checkbox'
import Pagination from '@/components/base/Pagination'
import Modal from '@/components/base/Modal'
import Search from '@/components/base/search/Search'
import CheckDataList from '@/components/base/CheckDataList'
import '@/components/base/select/Select'

// mixins
import { getListStatus } from '@/assets/js/mixins/common/GetListStatus'
import { swal } from '@/assets/js/mixins/base/Swal'

// libs
import axios from 'axios'
import moment from 'moment'
import { mapActions, mapState } from 'vuex'

export default {
  name: 'whitelist',

  components: {
    Pagination,
    Modal,
    Search,
    Checkbox,
    CheckDataList
  },

  mixins: [
    getListStatus,
    swal
  ],

  data () {
    let params = Object.assign({
      rows: 50,
      page: 1,
      filter_by: '',
      q: '',
      sort_by: 'id',
      sort: 'desc',
      date_from: '',
      date_to: ''
    }, this.$route.query)

    return {
      isEmpty: false,
      isDataLoading: true,
      showDataLoading: false,
      count: 0,
      tempWhitelist: {
        ip: null,
        description: null
      },
      params,
      showCreate: false,
      showModify: false,

      filterBy: [
        {
          value: 'ip',
          display: 'ip'
        },
        {
          value: 'description',
          display: '설명'
        }
      ],

      dateBy: [
        {
          value: 'created_at',
          display: '등록일자'
        }
      ],

      tblSetting: 'whitelist',

      allCols: [
        {
          display: 'no',
          value: 'no'
        },
        {
          display: 'ip',
          value: 'ip'
        },
        {
          display: 'description',
          value: 'description'
        },
        {
          display: 'status',
          value: 'status'
        },
        {
          display: 'created_at',
          value: 'created_at'
        },
        {
          display: 'updated_at',
          value: 'updated_at'
        },
        {
          display: 'deleted_at',
          value: 'deleted_at'
        }
      ]
    }
  },

  computed: {
    ...mapState('adminw', {
      whitelistsCount: 'whitelistsCount',
      whitelists: 'whitelists'
    }),

    checkPermission () {
      let permission = JSON.parse(window.localStorage.permission)
      let dbKey = this.$route.meta.dbKey
      let obj

      for (let key in permission) {
        if (dbKey === key) {
          obj = permission[key]
        }
      }

      return obj === 'rw' ? 1 : ''
    }
  },

  watch: {
    async '$route' ($router) {
      this.search(this.generate($router.query))
    },
    async showCreate () {
      this.tempWhitelist.ip = null
      this.tempWhitelist.description = null

      if (!this.showModify) {
        this.search()
      }
    }
  },

  async created () {
    if (this.$route.params.status === undefined) {
      this.$router.push(`${this.$route.path}/`)
    }

    this.query = this.generate(this.query)
    this.search(this.query)
  },

  methods: {
    ...mapActions({
      getWhitelist: 'adminw/fetch'
    }),

    trigger (query) {
      this.params = query || this.params
      this.$router.push({ query: this.params })
    },

    async sort (arg) {
      if (this.params.sort === 'asc') {
        this.params.sort = 'desc'
      } else {
        this.params.sort = 'asc'
      }

      this.params.sort_by = arg

      this.$router.push({ query: this.params })
    },

    async search (query) {
      this.query = query || this.query
      this.status = this.$route.params.status
      let params = Object.assign(this.query, { stat: this.$route.params.status })
      // == flags reset
      this.isEmpty = false

      if (!this.showDataLoading) {
        this.isDataLoading = true
      }

      try {
        await this.getWhitelist({ params })

        this.isDataLoading = false
        this.showDataLoading = false

        if (!this.whitelists.length) {
          this.isEmpty = true
        }
      } catch (err) {
        console.log(err)
      }
    },

    createViewer () {
      this.showCreate = true
      this.tempWhitelist.ip = null
      this.tempWhitelist.description = null
    },

    async saveWhiteList () {
      let success = async () => {
        let result = await axios.post('/admins/whitelist/add', {
          ip: this.tempWhitelist.ip,
          description: this.tempWhitelist.description
        })

        if (result.status === 201) {
          if (!result.data.errors) {
            this.$alert('success', '정상적으로 IP를 추가 하였습니다.', {}, '', '성공')
          } else if (result && result.data && result.data.msg === 'duplicate') {
            this.$alert('error', 'The IP already exist', {}, '', 'Error')
            this.showCreate = false
          }
        }
      }

      this.$alert('prompt', '정말 추가를 하시겠습니까?', {}, { success }, '화이트 IP추가')
    },

    async remove (item) {
      const success = async () => {
        const result = await axios.delete('/admins/whitelist/drop', {
          data: {
            id: item.id
          }
        })

        if (result.status === 202) {
          this.$alert('success', 'You have successfully remove an ip', {}, '', 'Success')
          this.search()
        }
      }

      this.$alert('prompt', '정말 IP를 삭제 하시겠습니까?', {}, { success }, '아이피 삭제')
    },

    dateFormatter (value) {
      if (value) {
        return moment(String(value)).format('YYYY-MM-DD HH:mm:ss')
      }
    }
  }
}
</script>

<style type="text/css" lang="scss" scoped>

</style>
